import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { ENV } from '@common/app/env';
import { Providers } from '@common/app/providers';
import { unsupportedPlatforms } from '@common/constants/platforms.ts';
import { UserInit } from '@components/UserInit/UserInit';

// import eruda from 'eruda';
import './i18n';

import { PostHogIdentificator } from './components/PostHogIdentificator/PostHogIdentificator';
import { PostHogProvider } from './components/PostHogProvider/PostHogProvider';
import QRCodeScreen from './QRCodeScreen/QRCodeScreen';
import store from './redux/store';
import App from './App';

import './index.scss';

// eruda.init();

const platform = Telegram?.WebApp?.platform || 'unknown';

// Tells the boot watchdog in index.html that the bundle loaded and ran.
window.__SI_BOOTED = true;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Auth0Provider
      domain={ENV.AUTH_ZERO_DOMAIN}
      clientId={ENV.AUTH_ZERO_CLIENT_ID}
      authorizationParams={{
        redirect_uri: ENV.API_BACKEND_URL + '/auth/auth0/callback',
        scope: 'openid profile email',
        audience: ENV.AUTH_ZERO_AUDIENCE,
      }}
    >
      {ENV.NODE_ENV === 'production1' &&
      unsupportedPlatforms.includes(platform) ? (
        <QRCodeScreen />
      ) : (
        <PostHogProvider>
          <Provider store={store}>
            <BrowserRouter>
              <UserInit>
                <Providers>
                  <HelmetProvider>
                    <PostHogIdentificator />
                    <App />
                  </HelmetProvider>
                </Providers>
              </UserInit>
            </BrowserRouter>
          </Provider>
        </PostHogProvider>
      )}
    </Auth0Provider>
  </StrictMode>,
);
